















































































































import Vue, { PropType } from 'vue';

import moment from 'moment';
import { IFetchQuoteProductDocumentsParams } from '@/services/document/document.types';

import {
  IDocumentTag,
  IQuoteProductDocument,
  QuoteProductDocument
} from '@/models';

import DocumentDetailOptionsButton from './DocumentDetailOptionsButton.vue';

export default Vue.extend({
  name: 'DocumentList',

  components: { DocumentDetailOptionsButton },

  props: {
    numDocuments: Number,
    documents: {
      type: Array as PropType<QuoteProductDocument[]>
    },
    queryParams: Object as PropType<IFetchQuoteProductDocumentsParams>,
    loading: Boolean
  },
  data() {
    return {
      search: '',
      MAX_TAG_DISPLAY_AMOUNT: 1,
      headers: [
        {
          text: '#',
          sortable: false,
          value: 'index',
          width: 50
        },
        {
          text: 'Title',
          sortable: false,
          value: 'quote_document.document.title'
        },
        {
          text: 'Tags',
          sortable: false,
          value: 'quote_document.document.tags',
          width: 200
        },
        {
          text: 'Revision',
          sortable: false,
          value: 'quote_document.document.latest_revision.revision',
          align: 'center',
          width: 20
        },

        {
          text: 'Owner',
          sortable: false,
          value: 'quote_document.document.latest_revision.owner',
          width: 150
        },
        {
          text: 'Created at',
          sortable: false,
          value: 'quote_document.document.created_at',
          width: 200
        },
        {
          text: 'Last Updated at',
          sortable: false,
          value: 'quote_document.document.latest_revision.uploaded_at',
          width: 200
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions',
          width: 200
        }
      ],

      errorMessage: '',
      detailErrorMessage: '',

      showAllTags: {} as Record<number, boolean> // Add this to track the expanded/collapsed state for each document
    };
  },

  computed: {
    params: {
      get(): IFetchQuoteProductDocumentsParams {
        return this.queryParams;
      },
      set(value) {
        this.$emit('update:queryParams', value);
      }
    },

    isLoading: {
      get(): boolean {
        return this.loading;
      },
      set(value: boolean) {
        this.$emit('update:loading', value);
      }
    }
  },

  methods: {
    moment,

    selectDocument(document: IQuoteProductDocument) {
      this.$emit('document-select-pressed', document);
    },

    displayedTags(document: IQuoteProductDocument, tags: IDocumentTag[]) {
      // Returns either all tags or a limited number
      return this.showAllTags[document.id!]
        ? tags
        : tags.slice(0, this.MAX_TAG_DISPLAY_AMOUNT);
    },

    toggleShowAllTags(document: IQuoteProductDocument) {
      // Toggle showAllTags state for this specific document
      Vue.set(this.showAllTags, document.id!, !this.showAllTags[document.id!]);
    },

    onUpdatePage(page: number) {
      this.$emit('update:page', page);
    }
  }
});
